<template>
  <v-app-bar
    app
    clipped-right
    color="primary"
    dark
    flat
  >
    <v-row
      align="center"
    >
      <v-col>
        <v-toolbar-title>
          <router-link
            class="white--text"
            :style="{ textDecoration: 'none' }"
            :to="{ name: 'home' }"
          >
            <v-avatar
              class="mr-1"
              size="32"
            >
              <v-img src="/favicon.png" />
            </v-avatar>
            ServersGG
            <span
              class="blue--text text--lighten-3 text-uppercase"
              style="font-size: 10px"
            >
              Alpha
            </span>
          </router-link>
        </v-toolbar-title>
      </v-col>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp && $route.name !== 'home'"
      >
        <SearchBox
          inverted
        />
      </v-col>
      <v-col
        class="text-right"
      >
        <template
          v-if="!$isLoggedIn"
        >
          <template
            v-if="$vuetify.breakpoint.mdAndUp"
          >
            <v-btn
              class="mr-2"
              text
              :to="{ name: 'userToken.create' }"
            >
              {{ $t('sign_in') }}
            </v-btn>
            <v-btn
              color="secondary"
              :to="{ name: 'user.create' }"
            >
              {{ $t('sign_up') }}
            </v-btn>
          </template>
          <template
            v-else
          >
            <v-btn
              fab
              small
              text
              @click="dialogs.mobileMenu.display = true"
            >
              <v-icon
                small
              >
                menu
              </v-icon>
            </v-btn>
            <v-dialog
              v-model="dialogs.mobileMenu.display"
              max-width="300"
            >
              <v-list>
                <v-list-item
                  :to="{ name: 'user.create' }"
                  @click="dialogs.mobileMenu.display = false"
                >
                  <v-list-item-title>
                    {{ $t('sign_up') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="{ name: 'userToken.create' }"
                  @click="dialogs.mobileMenu.display = false"
                >
                  <v-list-item-title>
                    {{ $t('sign_in') }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-dialog>
          </template>
        </template>
        <template
          v-else
        >
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                slot="activator"
                text
                v-bind="attrs"
                v-on="on"
              >
                {{ $user.data.name }}
                <v-icon
                  class="ml-1"
                >
                  arrow_drop_down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :to="{ name: 'account.details' }"
              >
                <v-list-item-title>
                  {{ $t('account') }}
                </v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item
                @click="dialogs.signOut.display = true"
              >
                <v-list-item-title>
                  {{ $t('sign_out') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-col>
    </v-row>
    <BaseDialog
      :display.sync="dialogs.signOut.display"
      :message="$t('sign_out_confirm')"
      :submit-label="$t('sign_out')"
      :title="$t('sign_out')"
      @submit="handleSignOut()"
    />
  </v-app-bar>
</template>

<script>
import get from 'lodash/get'

import BaseDialog from '@/components/BaseDialog'
import SearchBox from '@/components/SearchBox'

export default {
  name: 'AppBar',

  components: {
    BaseDialog,
    SearchBox,
  },

  data () {
    return {
      dialogs: {
        mobileMenu: {
          display: false,
        },
        signOut: {
          display: false,
        },
      },
    }
  },

  methods: {
    handleSignOut () {
      this.$store.dispatch('auth/logout')

      const accessibleTo = get(this.$route, 'meta.accessibleTo', [
        'guest',
        'user',
      ])

      if (!accessibleTo.includes('guest')) {
        this.$router.push({ name: 'server.index' })
      }

      this.$notify('info', this.$t('sign_in_success'))

      this.dialogs.signOut.display = false
    },
  },
}
</script>
